import { TotemDto } from "./TotemDto";

export class TotemIdentifyDto {

    totemSetting: TotemDto;
    searchText: string;

    static build(searchText: string, totemSetting: TotemDto): TotemIdentifyDto {
        let result = new TotemIdentifyDto();
        result.searchText = searchText;
        result.totemSetting = totemSetting;
        return result;
    }
}